export enum MetricClassificationLabel {
  Pass = 'Pass',
  High = 'High',
  Low = 'Low',
  Nodata = 'Nodata',
  NodataFailMetric = 'NodataFailMetric',
  Error = 'Error',
}
